module.exports = __webpack_public_path__ + "_assets/img/question-w.ff9a9e59.svg";